import React, { useState } from 'react';

import { ModalContainer, ModalClose } from 'shared/modals';
import { Categories, Category } from '../categories.types';
import { UploadImage } from './upload-image';
import { ImageLibrary } from './image-library';

type SelectImageModalProps = {
  onClose: () => void;
  category: Category;
  categories: Categories;
  onSave: (updatedCategories: Categories) => void;
};

export const SelectImageModal = ({
  onClose,
  category,
  categories,
  onSave,
}: SelectImageModalProps): JSX.Element | null => {
  const { category: value, image } = category;
  const [isUploadImageModalOpen, setIsUploadImageModalOpen] = useState(false);
  const closeModal = isUploadImageModalOpen ? () => setIsUploadImageModalOpen(false) : onClose;
  const [selectedImage, setSelectedImage] = useState(image);

  const saveImage = (): void => {
    const updatedCategories = categories.map((obj) =>
      obj.category === value ? { category: value, image: selectedImage, collectionId: obj.collectionId } : obj
    );

    onSave(updatedCategories);
    onClose();
  };

  const openUploadImageModal = (): void => {
    setIsUploadImageModalOpen(true);
  };

  return (
    <ModalContainer
      isOpen
      onRequestClose={closeModal}
      width='880px'
      alignItems='flex-start'
      padding='40px'
      ariaHideApp={false}
      textAlign='left'
      scrollable
    >
      <ModalClose onClick={closeModal} />

      {isUploadImageModalOpen ? (
        <UploadImage
          category={category}
          setSelectedImage={setSelectedImage}
          setIsUploadImageModalOpen={setIsUploadImageModalOpen}
        />
      ) : (
        <ImageLibrary
          category={category}
          saveImage={saveImage}
          openUploadImageModal={openUploadImageModal}
          selectedImage={selectedImage}
          setSelectedImage={setSelectedImage}
        />
      )}
    </ModalContainer>
  );
};
